import type { CountryRegionsConfigResponse } from "@warrenio/api-spec/spec.oats.gen";

export const countryRegionsConfigExample = {
    AU: {
        states: [],
    },
    EE: {
        states: [],
    },
    IN: {
        states: [
            { code: "AN", name: "Andaman And Nicobar Islands" },
            { code: "AP", name: "Andhra Pradesh" },
            { code: "AR", name: "Arunachal Pradesh" },
            { code: "AS", name: "Assam" },
            { code: "BR", name: "Bihar" },
            { code: "CH", name: "Chandigarh" },
            { code: "CT", name: "Chhattisgarh" },
            { code: "DL", name: "Delhi" },
            { code: "GA", name: "Goa" },
            { code: "GJ", name: "Gujarat" },
            { code: "HR", name: "Haryana" },
            { code: "KA", name: "Karnataka" },
            { code: "KL", name: "Kerala" },
            { code: "MH", name: "Maharashtra" },
            { code: "RJ", name: "Rajasthan" },
            { code: "TN", name: "Tamil Nadu" },
            { code: "UP", name: "Uttar Pradesh" },
            { code: "WB", name: "West Bengal" },
        ],
    },
    MQ: {
        states: [],
    },
    NL: {
        states: [],
    },
} satisfies CountryRegionsConfigResponse;

// cspell:words Andhra Arunachal Chhattisgarh Haryana Karnataka Nadu Pradesh Uttar
